import { Page } from "@roc/feature-app-core";
import { Route } from "react-router";
import { AppraisalTechControlDashboard } from "../components/appraisalTechControlDashboard";

export const getAppraisalTechControlDashboardInternalRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    appraisalTechControlDashboard: {
      path: `${basePath}/appraisal-tech-control-dashboard`,
      url: `${baseUrl}/appraisal-tech-control-dashboard`,
      documentTitle: 'appraisal-tech-control-dashboard',
    }
  }
};

export const getAppraisalTechControlDashboardInternalRoutes = (
  basePath: string,
  baseUrl: string,
) => {
  const config = getAppraisalTechControlDashboardInternalRoutesConfig(basePath, baseUrl);

  return {
    appraisalTechControlDashboard: (
      <Route exact path={config.appraisalTechControlDashboard.path}>
        <Page routeDefinition={config.appraisalTechControlDashboard}>
          <AppraisalTechControlDashboard/>
        </Page>
      </Route>
    )
  }
}